export interface UpdateSystemCodeAreaRequest {
  codes: {
    code: string
    name: string
    shortName: string
    revision: number
  }[]
}

export function UpdateSystemCodeAreaRequestToJSON(
  value: UpdateSystemCodeAreaRequest
): any {
  return {
    codes:
      value.codes.length > 0
        ? value.codes.map(code => {
            return {
              code: code.code !== '' ? code.code : undefined,
              name: code.name !== '' ? code.name : undefined,
              short_name: code.shortName !== '' ? code.shortName : undefined,
              revision: code.revision !== 0 ? code.revision : undefined
            }
          })
        : undefined
  }
}
